// Lets the first gallery image finish before the peeking slide's image starts downloading (see the matching rule in ejanse.css).
// Loaded as a classic deferred script, because it sits above the theme's import map in <head>.
(function () {
  const READY_FALLBACK_MS = 6000;

  for (const gallery of document.querySelectorAll('media-gallery')) {
    const ready = () => gallery.setAttribute('data-ejanse-ready', '');
    const first = gallery.querySelector('slideshow-slide img');

    if (!first || first.complete) {
      ready();
    } else {
      first.addEventListener('load', ready, { once: true });
      first.addEventListener('error', ready, { once: true });
      setTimeout(ready, READY_FALLBACK_MS);
    }
  }
})();
